import { render } from "./BurgerMenu.vue?vue&type=template&id=760fcdb3&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=760fcdb3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760fcdb3"]])

export default __exports__